import React from "react";
import { Navigate } from "react-router-dom";

const AuthLayout = (props) => {
  return <React.Fragment>{props.children}</React.Fragment>;
};

export default AuthLayout;
